import React, { useEffect, useState } from 'react';

import { useFlags, withLDProvider } from 'launchdarkly-react-client-sdk';

import { init } from './services/core';

import MyTeam from './containers/MyTeam';
import MyAccountLegacy from './containers/MyAccountLegacy';
import MyAccount from './containers/MyAccount';

export const getLDRelayURL = () => {
  let env = '';
  const smilesDomain = window.location.hostname.indexOf('smiles.com.br') > -1;
  const rx = smilesDomain ? /^(.*)\.smiles\.com\.br/g : /^(.*)\.voebiz\.com\.br/g;
  const res = rx.exec(window.location.hostname);
  if (res !== null) {
    if (res.length > 1 && res[1] && res[1].length > 3) {
      env = res[1];
    }
    env = env.replace(/portal|voebiz/g, '').replace('uat', 'hml');
  }
  if (window.location.hostname === 'localhost') {
    env = '-hml5';
  }
  return `https://ldrelay${env}.smiles.com.br`;
};

const clientSideId = '62baf3989195871574e35e6c';
const launchDarklyURL = getLDRelayURL();
interface AppProps extends JSX.IntrinsicAttributes {
  cardSize: string | null;
  componentType: string | null;
}
const renderMainComponent = (componentType: string, cardSize: string | null) => {
  if (componentType === 'my-team') {
    return <MyTeam />;
  }
  if (componentType === 'v2') {
    return <MyAccount />;
  }
  return <MyAccountLegacy cardSize={cardSize} />;
};

function App({ componentType, cardSize }: AppProps) {
  const [loading, setLoading] = useState(true);
  const { apiDomain } = useFlags();
  async function initializeCore() {
    await init();
  }
  useEffect(() => {
    initializeCore();
  }, []);
  useEffect(() => {
    if (apiDomain) {
      setLoading(false);
    }
  }, [apiDomain]);

  if (loading) {
    return <div />;
  }
  return <div className="vbz-lf">{componentType && renderMainComponent(componentType, cardSize)}</div>;
}

export default withLDProvider<AppProps>({
  clientSideID: clientSideId,
  user: { key: window.location.origin },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  options: {
    baseUrl: launchDarklyURL,
  },
})(App);
